import * as React from 'react';

import EnterpriseToolTabs from 'bundles/internal-enterprise/components/EnterpriseToolTabs';

type Props = React.PropsWithChildren<{
  params: {
    userId: string;
  };
}>;

const UserMembershipsRouteHandler = ({ params, children }: Props) => (
  <div className="rc-UserMembershipRouteHandler">
    <EnterpriseToolTabs userId={params.userId} />
    {children}
  </div>
);

export default UserMembershipsRouteHandler;
